import { Messages } from '../../codegen/Localize';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { CommonErrorCode, DatasourceErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { DataSources } from '../../content/resources/Datasources';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ToasterService, ToastType } from './ToasterService';

export class ChangeDatasourceDescriptionAction {

  public static $inject = ['$translate'];

  constructor(
    private $translate: ng.translate.ITranslateService) { }

  public execute(datasource: IDataSourceBase, newDescription: string): Promise<IResult> {

    return DataSources.setDescription(datasource.id, newDescription).then((result: IResult) => {
      if (result.errors && result.errors.length) {
        ToasterService.instance.pop({ type: ToastType.Error, text: this.errorMessageFor(result.errors[0], datasource) });
      } else {
        ToasterService.instance.pop({ type: ToastType.Success, text: Messages.editDescriptionSuccessful() });
      }
      return result;
    });

  }

  private errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      case DatasourceErrorCode.DatasourceDescriptionGreaterThanMaxLength:
        return this.$translate.instant('errorDatasourceDescriptionTooLong', { MAX_LENGTH: getSessionManagementServiceInstance().maxDescriptionLength() });
      case CommonErrorCode.DatasourceNotFound:
        return this.$translate.instant('errorDatasourceNotFound', { DATASOURCE_NAME: L10n.elideIfLong(datasource.name) });
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ChangeDatasourceDescriptionAction', ChangeDatasourceDescriptionAction);
